import React, { Component } from 'react';
import {GetData,PostData} from '../../services/PostData';
import axios from 'axios';
class SpeechGenerateStg extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userInput: '',
            selectedVoice: '',
            selectedCategory: 'all',
            voices: [],
            categories: ['all', 'Male', 'Female', 'Child'],
            isVoiceSelected: false,
            isSuccessfull: false,
            sucsmsg: 'Text converted to speech successfully',
            audioUrl: null,
            speechList: [],
            voice:""
        };
    }

    componentDidMount() {
        this.fetchVoices();
    }

    // Method to fetch voice data from an API
    fetchVoices = async () => {
        GetData('voice/list').then((result) => {
            this.setState({voices: result.voiceList.voices})
        });
        this.fetchSpeechList();
    }

    fetchSpeechList = () => {
        // GetData(`get/all/speech/list/${this.props.match.params.orgid}`).then((result) => {
        GetData(`get/all/speech/list`).then((result) => {
            this.setState({speechList: result.speechList})
        });
    }

    handleInputChange = (event) => {
        this.setState({
            userInput: event.target.value
        });
    }

    handleVoiceSubmit = async (event) => {
        event.preventDefault();
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;
        const text = this.state.userInput;
        const voiceID = this.state.selectedVoice;
        const userId= userdata.user.ID;
        const elevenlabs = 'sk_cf9ad6f7b71d59b2f7e6afb7d3cb16b27e33f279575de36e';
        let data = {
            text: text,
            voice_settings: {
                stability: 0.1,
                similarity_boost: 0.3,
                style: 0.2
            }
        }
        const audioStream = await axios.post(`https://api.elevenlabs.io/v1/text-to-speech/${voiceID}`, data, {
            headers: {
                'xi-api-key': elevenlabs
            },
            responseType: 'stream'
        })

        this.setState({
            voice: audioStream.data
        });
         console.log('audioStream', audioStream)
    }

    // Method to handle form submission
    handleVoiceSubmit_old = (event) => {
        event.preventDefault();
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;
        PostData('text/to/speech', {
            voiceID: this.state.selectedVoice,
            // voiceID: "EXAVITQu4vr4xnSDxMaL",
            text: this.state.userInput,
            // orgId: this.props.match.params.orgid,
            userId: userdata.user.ID
        }).then(async (result) => {
            // console.log('result==',result);
            this.fetchSpeechList();
            this.setState({
                isVoiceSelected: false,
                isSuccessfull: true,
                userInput: '',
                selectedVoice: ''
            })
            setTimeout(() => {
                this.setState({  isSuccessfull: false});
            }, 5000);
        });
    }

    handleVoiceSelection = (voice) => {

        this.setState({
            selectedVoice: voice.target.value,
            isVoiceSelected: true
        });
    }

    // Method to handle category filter selection
    handleCategoryChange = (event) => {
        this.setState({
            selectedCategory: event.target.value
        });
    }

    // Get filtered voices based on selected category
    getFilteredVoices = () => {
        const { voices, selectedCategory } = this.state;
        if (selectedCategory === 'all') {
            return voices;
        }
        return voices.filter(voice => voice.category === selectedCategory);
    }

    handleButtonClick = (voice) => {
        // Handle button click (e.g., play audio, edit, delete)
        console.log(`Button clicked for: ${voice.text}`);
        // You can add any specific functionality here
    }

    render() {
        const { selectedVoice } = this.state;
        // const filteredVoices = this.getFilteredVoices();

        return (
            <div  style={{background: '#fff', padding: '0px 90px'}}>
                {/* <h3>Select a Voice</h3>
                <label htmlFor="categoryFilter">Filter by Category: </label>
                <select id="categoryFilter" value={selectedCategory} onChange={this.handleCategoryChange}>
                    {categories.map((category, index) => (
                        <option key={index} value={category}>{category}</option>
                    ))}
                </select>

                <div style={{ marginTop: '20px' }}>
                    <h4>Available Voices:</h4>
                    <ul>
                        {filteredVoices.map(voice => (
                            <li key={voice.id}>
                                <button onClick={() => this.handleVoiceSelection(voice)} className="UpdateBtn btn btn-primary" style={{backgroundColor: '#fff', color: '#000'}}>
                                    {voice.name} ({voice.category})
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                {selectedVoice && (
                    <div>
                        <h4>Selected Voice: {selectedVoice}</h4>
                    </div>
                )} */}

            <h3>Generate speech</h3>
                {/* <label htmlFor="categoryFilter">Filter  by Category: </label>
                <select id="categoryFilter" value={selectedCategory} onChange={this.handleCategoryChange}>
                    {categories.map((category, index) => (
                        <option key={index} value={category}>{category}</option>
                    ))}
                </select> */}

                <div style={{ marginTop: '20px' }}>
                    <label htmlFor="voiceDropdown">Select a Voice: </label>
                    <select id="voiceDropdown" value={selectedVoice} onChange={this.handleVoiceSelection}>
                        <option value="" disabled>Select a voice</option>
                        {this.state.voices.map(voice => (
                            <option key={voice.id} value={voice.voice_id}>
                                {voice.name} ({voice.category}) {`${voice.labels.gender} ${voice.labels.accent}`}
                            </option>
                        ))}
                    </select>
                </div>

                {/* {selectedVoice && (
                    <div>
                        <h4>Selected Voice: {selectedVoice}</h4>
                    </div>
                )} */}

                <br/>
                <h5>Type your script below to convert to speech</h5>
                <form onSubmit={this.handleVoiceSubmit}>            
                    <textarea
                        value={this.state.userInput}
                        onChange={this.handleInputChange}
                        placeholder="Type or paste your text here..."
                        rows="10"
                        cols="50"
                    />
                    <br />
                        {this.state.isSuccessfull && <div className="successmsg">{this.state.sucsmsg}</div>}
                    <br/>
                    <button type='submit' >Submit</button>
                </form>
                <br />
                <br />
                { (this.state.voice &&
                 <div className="speech-list">
                    
                        <div  className="card">
                            <div className="card-content">
                                <h4>test</h4> {/* Display the text */}
                                <audio controls className="audio-player">
                                    <source src={this.state.voice} type="audio/mpeg" />
                                    Your browser does not support the audio element.
                                </audio>
                                {/* <button 
                                    className="action-button"
                                    onClick={() => this.handleButtonClick(voice)} // Call the button click handler
                                >
                                    Add to project
                                </button> */}
                            </div>
                        </div>
                    
                </div>
                )}
            </div>
        );
    }
}

export default SpeechGenerateStg